import React, { useEffect, useState } from 'react'
import './index.css'

export default function ToogleButton({id, active, setActive}) {

    const [isChecked, setIsChecked] = useState(active)

    const handleChecked = () => {
        setIsChecked(document.getElementById(id).checked)
        // console.log(document.getElementById(id).checked);
    }

    useEffect(() => {
        setActive(isChecked)
    }, [isChecked])

    useEffect(() => {
        document.getElementById(id).checked = !active
    }, [])

    return (
        <label className="switch">
            <input type="checkbox" id={id} />
            <span className="slider round" onClick={handleChecked}></span>
        </label>
    )
}
